export const notificationsRoutes = [
  {
    name: 'Notifications',
    path: '/notifications',
    component: () => import('@/modules/notifications/containers/notifications-listing.container.vue'),
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'notifications',
    },
  },
  {
    name: 'Notification Details',
    path: '/notifications/:id',
    component: () => import('@/modules/notifications/containers/notifications-detail.container.vue'),
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'notifications',
    },
  },
]

export default notificationsRoutes
